/**
 * 표 머리글을 눌렀을 때 정렬이 어떻게 바뀌는가.
 *
 * 처음 누르면 오름차순, 같은 칸을 다시 누르면 내림차순, 한 번 더 누르면 정렬을 푼다
 * (기본 순서 = 접수일 최신순으로 돌아간다). 세 번째 누름이 없으면 한 번 정렬한 뒤에는
 * 기본 순서로 돌아갈 방법이 없다.
 */
export type SortDir = "asc" | "desc"
export type SortState = { sort: string | null; dir: SortDir }

export function nextSort(current: SortState, clicked: string): SortState {
  if (current.sort !== clicked) return { sort: clicked, dir: "asc" }
  if (current.dir === "asc") return { sort: clicked, dir: "desc" }
  return { sort: null, dir: "asc" }
}

/** URL 에 실을 모양. 정렬을 풀면 두 열쇠 모두 뺀다. */
export function sortParams(state: SortState): Record<string, string | null> {
  return state.sort === null ? { sort: null, dir: null } : { sort: state.sort, dir: state.dir }
}
